import { h } from 'preact'
import brandenburg from './brandenburg.svg'
import berlin from './berlin.svg'
import _ from './styles.sass'

function latLngToMercartor ({ lat, lng }) {
  const x = (lng + 180) * (1 / 360)

  // convert from degrees to radians
  const latRad = lat * Math.PI / 180

  // get y value
  const mercN = Math.log(Math.tan((Math.PI / 4) + (latRad / 2)))
  const y = (1 / 2) - (mercN / (2 * Math.PI))

  return { x, y }
}

function getRelativePositionInBoundingBox ({ topLeftLatLng, bottomRightLatLng, pointLatLng }) {
  const topLeft = latLngToMercartor(topLeftLatLng)
  const bottomRight = latLngToMercartor(bottomRightLatLng)
  const width = bottomRight.x - topLeft.x
  const height = bottomRight.y - topLeft.y
  const point = latLngToMercartor(pointLatLng)

  return {
    x: (point.x - topLeft.x) / width,
    y: (point.y - topLeft.y) / height
  }
}

const brandenburgBounds = {
  topLeftLatLng: { lat: 53.5590907, lng: 11.267355 },
  bottomRightLatLng: { lat: 51.159064, lng: 14.7658159 }
}

const berlinBounds = {
  topLeftLatLng: { lat: 52.69, lng: 13.06 },
  bottomRightLatLng: { lat: 52.32, lng: 13.79 }
}

const MarkerOnMapShape = (props) => {
  const { color, feature, isInBerlin } = props

  const coords = feature.geometry.coordinates
  const { x, y } = getRelativePositionInBoundingBox({
    ...(isInBerlin ? berlinBounds : brandenburgBounds),
    pointLatLng: { lat: coords[1], lng: coords[0] }
  })

  const markerSize = { width: 12, height: 16 }
  const imageSize = isInBerlin
    ? { width: 50, height: 41 }
    : { width: 50, height: 52 }
  const imgSrc = isInBerlin ? berlin : brandenburg
  const position = {
    top: `${y * imageSize.height - markerSize.height}px`,
    left: `${x * imageSize.width - markerSize.width / 2}px`
  }

  return <div class={_.wrapper}>
    <div class={`${_.shapeWrapper} ${isInBerlin && _.isInBerlin}`}>
      <img src={imgSrc} width={imageSize.width} height={imageSize.height} />
      <svg class={_.marker} width={markerSize.width} height={markerSize.height} style={position} viewBox='-10 0 288 352' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <path fill={color} stroke='white' strokeWidth='20' d='M101.003681,274.201165 C94.763682,259.74013 80.7989308,256.219867 73.9452637,252.761886 C30.3788436,230.78068 0.5,185.629629 0.5,133.5 C0.5,59.7699859 60.2699859,0 134,0 C208.230014,0 268,59.7699859 268,133.5 C268,185.629629 238.121156,230.78068 194.554736,252.761886 C187.701069,256.219867 173.736318,259.74013 167.496319,274.201165 L134.294922,351.144531 C134.254994,351.049158 123.157914,325.401369 101.003681,274.201165 Z' />
      </svg>
    </div>
  </div>
}

export default MarkerOnMapShape
